export default {
  data() {
    return {
      touchStartX: 0,
      touchStartY: 0,
      touchEndX: 0,
      touchEndY: 0,
      swipeThreshold: 50, // Mínima distancia para considerar un swipe
      edgeThreshold: 30, // Distancia desde el borde para detectar swipe
    }
  },
  
  mounted() {
    // Agregar listeners para detectar swipe
    document.addEventListener('touchstart', this.handleTouchStart, { passive: true });
    document.addEventListener('touchend', this.handleTouchEnd, { passive: true });
  },
  
  beforeDestroy() {
    // Limpiar listeners
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchend', this.handleTouchEnd);
  },
  
  methods: {
    handleTouchStart(event) {
      const touch = event.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    },
    
    handleTouchEnd(event) {
      const touch = event.changedTouches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
      
      this.handleSwipe();
    },
    
    handleSwipe() {
      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      
      // Verificar que el movimiento sea más horizontal que vertical
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        // Swipe desde el borde izquierdo para abrir
        if (this.touchStartX < this.edgeThreshold && deltaX > this.swipeThreshold) {
          this.onSwipeRight();
        }
        // Swipe hacia la izquierda para cerrar (desde cualquier parte)
        else if (deltaX < -this.swipeThreshold && this.$sidebar && this.$sidebar.showSidebar) {
          this.onSwipeLeft();
        }
      }
    },
    
    onSwipeRight() {
      // Abrir sidebar solo en móvil
      if (window.innerWidth <= 991 && this.$sidebar) {
        this.$sidebar.displaySidebar(true);
      }
    },
    
    onSwipeLeft() {
      // Cerrar sidebar solo en móvil
      if (window.innerWidth <= 991 && this.$sidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
}
